<template>
  <transition name="modal">
    <div v-if="shown" @click="close" class="modal modal-mask" style="display: block">
      <div class="modal-dialog" role="document">
        <div class="modal-content" @click.stop>
          <button @click="close" type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'app-modal',
  props: {
    shown: {
      type: Boolean,
    },
  },
  mounted() {
    document.addEventListener('keydown', e => {
      if (this.shown && e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal ::v-deep .center-content-position {
  width: 90%;
  margin: auto;
  @include tablet {
    width: 40%;
  }
}
</style>

<style>
.modal-content {
  padding: 20px 20px 40px;
  transition: all 0.3s ease;
}
.modal .modal-content p {
  position: unset;
}
.modal-content h1 {
  color: #55a9eb;
}
.modal-content form label {
  color: #b0b1ba;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 5px;
}
.modal-content .btn-link {
  color: rgb(66, 139, 202);
}
.modal-content .btn-link:hover {
  color: rgb(42, 100, 150);
  text-decoration: none;
}
.full-width-modal .modal-dialog {
  width: 95%;
  margin: 10px auto;
}
.modal-enter,
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.1);
}
</style>
